/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A product counts as configured when it is live and no longer ready for configuration. INVESTMENT_PRODUCT_CONFIGURED - "Investment product": at least one investment product is configured. Only listed when the business relation type and sub type require an investment product. EBANKING_CONFIGURED - "E-Banking": at least one E-Banking product is configured. Only listed when the business relation has a live service model whose service model code triggers the automatic opening of E-Banking. ALL_PRODUCTS_CONFIGURED - "All configured": every live product is configured. Only listed when the business relation has at least one live product.
 * @export
 */
export const ProfilingWizardChecklistItemId = {
    InvestmentProductConfigured: 'INVESTMENT_PRODUCT_CONFIGURED',
    EbankingConfigured: 'EBANKING_CONFIGURED',
    AllProductsConfigured: 'ALL_PRODUCTS_CONFIGURED'
} as const;
export type ProfilingWizardChecklistItemId = typeof ProfilingWizardChecklistItemId[keyof typeof ProfilingWizardChecklistItemId];


export function instanceOfProfilingWizardChecklistItemId(value: any): boolean {
    for (const key in ProfilingWizardChecklistItemId) {
        if (Object.prototype.hasOwnProperty.call(ProfilingWizardChecklistItemId, key)) {
            if (ProfilingWizardChecklistItemId[key as keyof typeof ProfilingWizardChecklistItemId] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProfilingWizardChecklistItemIdFromJSON(json: any): ProfilingWizardChecklistItemId {
    return ProfilingWizardChecklistItemIdFromJSONTyped(json, false);
}

export function ProfilingWizardChecklistItemIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfilingWizardChecklistItemId {
    return json as ProfilingWizardChecklistItemId;
}

export function ProfilingWizardChecklistItemIdToJSON(value?: ProfilingWizardChecklistItemId | null): any {
    return value as any;
}

export function ProfilingWizardChecklistItemIdToJSONTyped(value: any, ignoreDiscriminator: boolean): ProfilingWizardChecklistItemId {
    return value as ProfilingWizardChecklistItemId;
}

